import { Box, IconButton } from "@mui/material";
import React from "react";
import { CustomButton, TextField } from "../../../v2/MUI_custom_component";
import GlassModal from "../../../v2/MUI_custom_component/Modal/GlassModal";
import OTPVerificationComponent from "../OTPVerification/OTPVerificationComponent";
import { MOBILE_REGEX } from "../../Auth/Register/Components/regex";
import { encryptPassword } from "../../../v2/Utils/Encryption/NodeForgeEncryption";
import { OTP_PURPOSE_ENUM } from "../../Auth/Enum";
import { sendOTPAction, verifyOTPAction } from "../../Auth/Register/API/Action";
import { useSelector } from "react-redux";
import IconReusable from "../../../components/IconReusable";
import { useEffect } from "react";

const VerifyWhatsapp = ({
  label = "Whatsapp Number",
  placeholder = "Enter Whatsapp number",
  helperText = "This helps us communicate better.",
  initialValue = "",
  disabled = false,
  onVerified,
  onClose,
  showCloseIcon = false,
  labelDirection = "column",
  containerSx = {},
  textFieldSx = {},
  verifyButtonSx = {},
  // action-button row (Cancel + Verify side by side)
  showActionButtons = false,
  cancelLabel = "Cancel",
  verifyLabel = "Verify",
  onCancel,
  onVerify,
  buttonsSx = {},
}) => {
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);
  const [whatsappError, setWhatsappError] = React.useState("");
  const [whatsappNumber, setWhatsappNumber] = React.useState(
    String(initialValue || "")
      .replace(/\D/g, "")
      .slice(0, 10),
  );
  const isMobileValid = MOBILE_REGEX.test(whatsappNumber || "");
  const encryptedMobile = encryptPassword(whatsappNumber);
  const userId = useSelector((state) => state.loginReducer.loginUser?.user_id);
  const encryptedUserId = encryptPassword(String(userId));
  const onVerifyClick = () => {
    if (!whatsappNumber) {
      setWhatsappError("Please enter WhatsApp number");
      return;
    }

    if (!isMobileValid) {
      setWhatsappError("Please enter a valid 10-digit mobile number");
      return;
    }
    handleResendOTP();
    setOpenVerifyModal(true);
  };
  const handleResendOTP = async () => {
    const payload = {
      mobile_number: encryptedMobile,
      purpose: OTP_PURPOSE_ENUM.WHATSAPP,
      user_id: encryptedUserId,
    };
    const { error, message } = await sendOTPAction(payload);
    if (!error) {
      return { success: true, message };
    } else {
      return { success: false, message };
    }
  };
  const handleVerifyOTP = async (otp) => {
    const payload = {
      mobile_number: encryptedMobile,
      otp: encryptPassword(otp),
      purpose: OTP_PURPOSE_ENUM.WHATSAPP,
      user_id: encryptedUserId,
    };
    const { data, error, message } = await verifyOTPAction(payload);
    if (!error) {
      return { success: true, data, message, vfc_token: data.vfc_token };
    } else {
      return { success: false, message };
    }
  };
  const handleVerifySuccess = async (result) => {
    setOpenVerifyModal(false);
    if (onVerified) {
      await onVerified({ ...result, whatsappNumber });
    }
    if (onVerify) {
      onVerify();
    }
  };
  const handleMobileChange = (e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 10);
    setWhatsappNumber(val);
    if (whatsappError) {
      setWhatsappError("");
    }
  };

  useEffect(() => {
    setWhatsappNumber(
      String(initialValue || "")
        .replace(/\D/g, "")
        .slice(0, 10),
    );
  }, [initialValue]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: labelDirection,
          alignItems: "center",
          gap: 1,
          ...containerSx,
        }}>
        <TextField
          label={label}
          value={whatsappNumber}
          onChange={handleMobileChange}
          placeholder={placeholder}
          variant="outlined"
          helperText={whatsappError || helperText}
          error={!!whatsappError}
          inputProps={{ maxLength: 10, inputMode: "numeric" }}
          fullWidth
          disabled={disabled}
          sx={textFieldSx}
        />

        {showActionButtons ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 1.5,
              width: "100%",
              mt: 0.5,
              ...buttonsSx,
            }}>
            <CustomButton
              variant="outlined"
              color="primary"
              label={cancelLabel}
              onClick={onCancel || onClose}
              sx={{ flex: 1 }}
            />
            <CustomButton
              variant="filled"
              color="primary"
              label={verifyLabel}
              onClick={onVerifyClick}
              sx={{ flex: 1, ...verifyButtonSx }}
            />
          </Box>
        ) : (
          <>
            <CustomButton
              variant="text"
              color="primary"
              label={verifyLabel}
              onClick={onVerifyClick}
              sx={verifyButtonSx}
            />
            {showCloseIcon && (
              <IconButton onClick={onClose} size="small" sx={{ p: 0 }}>
                <IconReusable
                  name="Close"
                  color="#333"
                  width={"24px"}
                  height={"24px"}
                />
              </IconButton>
            )}
          </>
        )}
      </Box>
      <GlassModal
        open={openVerifyModal}
        onClose={() => setOpenVerifyModal(false)}
        title="Verify Whatsapp Number"
        maxWidth="560px"
        maxHeight="30%">
        <OTPVerificationComponent
          mobileNumber={whatsappNumber}
          onVerify={handleVerifyOTP}
          onResend={handleResendOTP}
          purpose="whatsappVerification"
          otpLength={4}
          initialTimer={60}
          showMobileNumber
          onAnimationComplete={handleVerifySuccess}
        />
      </GlassModal>
    </>
  );
};

export default VerifyWhatsapp;
